import faLang from './locales/fa_IR';
import enLang from './locales/en_US';
import esLang from './locales/es_ES';

const AppLocale = {
  fa: faLang,
  en: enLang,
  es: esLang,
};

export default AppLocale;
